module.exports = __webpack_public_path__ + "static/media/plus_black.c314ec93.svg";